import { PlanGroup } from 'logic/subscription/plan/types'

export function describePlanGroup(planGroup: PlanGroup) {
  return {
    getFreePlanType: () => `FREE_PLAN_${planGroup}` as const,
  }
}
